import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComic = comics[3]; // 龙之继承者 as featured

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20fantasy%20illustration%2C%20magical%20dragon%20and%20hero%20silhouette%2C%20golden%20amber%20warm%20lighting%2C%20dramatic%20composition%2C%20cinematic%20background%2C%20soft%20bokeh%20effects%2C%20mystical%20atmosphere%2C%20high%20detail%20digital%20art%2C%20vibrant%20but%20not%20oversaturated&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="韩漫漫画网 - 免费高清韩漫在线阅读"
        title="韩漫漫画网 - 高清韩国漫画无遮挡下拉式阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/40 via-foreground-900/25 to-foreground-900/50"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="w-full">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex -space-x-2">
                  <div className="w-10 h-10 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20soft%20lighting%2C%20clean%20minimal%20background%2C%20warm%20expression%2C%20professional%20headshot&width=80&height=80&seq=hero-avatar-1&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20smile%2C%20professional%20headshot&width=80&height=80&seq=hero-avatar-2&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20cute%20woman%20portrait%2C%20bright%20lighting%2C%20clean%20minimal%20background%2C%20cheerful%20smile%2C%20professional%20headshot&width=80&height=80&seq=hero-avatar-3&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                </div>
                <span className="text-background-50/90 text-sm font-medium">已有 208 万漫迷的追更选择</span>
              </div>

              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-3">
                免费高清韩漫
              </h1>
              <p className="font-heading text-xl md:text-2xl lg:text-3xl text-background-50/80 italic mb-8">
                无遮挡下拉式阅读
              </p>

              <Link
                to="/category/love"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-base font-medium hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="hidden lg:flex flex-col items-end">
              <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 max-w-sm">
                <p className="text-background-50/90 text-sm leading-relaxed">
                  精选推荐 · {featuredComic.title} - 拥有龙之血脉的少年踏上冒险之路，在魔法与剑的世界中书写传奇。评分 {featuredComic.rating}，已更新至第 {featuredComic.latestChapter} 话。
                </p>
                <Link
                  to={`/article/${featuredComic.slug}`}
                  className="inline-flex items-center gap-1 mt-3 text-background-50 text-sm font-medium hover:text-primary-300 transition-colors cursor-pointer"
                >
                  立即阅读 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}